import Avatar from '@/components/common/Avatar';
import { Button } from '@/components/common/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/common/DropdownMenu';
import Tooltip from '@/components/common/Tooltip';
import { useStore } from '@/hooks/useStore';
import { ROLE } from '@/types/enums';
import { getAvatarFallbackName } from '@/utils/utils';
import { LogOutIcon, QrCode } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BusinessLoginQrModal from '@/pages/user/list/components/BusinessLoginQrModal';

export default observer(function UserAvatar() {
    // hooks
    const { t } = useTranslation();

    // store
    const { authStore: { logout, profile, info } } = useStore();

    // 2026-05-16 (B2B fix): BUSINESS が自分の PWA ログイン QR を確認するためのモーダル。
    // ADMIN は /users 画面で他 BUSINESS user の QR を見れるので、ADMIN の avatar には不要。
    const isBusiness = info?.role_id === ROLE.BUSINESS;
    const [qrOpen, setQrOpen] = useState(false);

    return (
        <>
            <DropdownMenu>
                <Tooltip
                    content={t('words_title.profile')}
                    triggerAsChild={true}
                    side='bottom'
                    align='end'
                >
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant='outline'
                            className='relative h-8 w-8 rounded-full'
                        >
                            <Avatar className='bg-black' fallback={getAvatarFallbackName(profile?.fullname)} />
                        </Button>
                    </DropdownMenuTrigger>
                </Tooltip>

                <DropdownMenuContent className='w-56' align='end' forceMount>
                    <DropdownMenuLabel className='font-normal'>
                        <div className='flex flex-col space-y-1'>
                            <p className='text-sm font-medium leading-none'>
                                {info?.username}
                            </p>
                            <p className='text-xs leading-none text-muted-foreground'>
                                {info?.email}
                            </p>
                        </div>
                    </DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    {/* 2026-05-16 (B2B fix): BUSINESS user は自分の PWA ログイン QR を avatar から確認可。
                        ADMIN は /users 画面で他 BUSINESS の QR を見れるので、ここには出さない。 */}
                    {isBusiness && (
                        <>
                            <DropdownMenuItem
                                className='hover:cursor-pointer'
                                onClick={() => setQrOpen(true)}
                            >
                                <QrCode className='w-4 h-4 mr-3 text-muted-foreground' />
                                自分のログイン QR を表示
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                        </>
                    )}
                    <DropdownMenuItem
                        className='hover:cursor-pointer'
                        onClick={logout}
                    >
                        <LogOutIcon className='w-4 h-4 mr-3 text-muted-foreground' />
                        {t('words_title.sign_out')}
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            <p>
                {info?.username}
            </p>

            {/* 2026-05-16 (B2B fix): BUSINESS 自分の QR modal (= 既存 component を再利用) */}
            {isBusiness && (
                <BusinessLoginQrModal
                    open={qrOpen}
                    onOpenChange={setQrOpen}
                    username={info?.username ?? null}
                />
            )}
        </>
    );
});
